import {
    Divider,
    Grid,
    GridColumn,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow
} from "semantic-ui-react";
import * as React from "react";
import { CreationProject, UsageProject } from "../../../stores/project/project";
import "./area-data-usage-project.css"
import { Link } from "react-router-dom";
import { useState } from "react";
import SVG from "react-inlinesvg";
import locateIcon from "../../../assets/images/icons/plain/map_location2.svg";
import editIcon from "../../../assets/images/icons/plain/pencil.svg";
import deleteIcon from "../../../assets/images/icons/plain/navigate_cross.svg";
import collapseIcon from "../../../assets/images/icons/plain/navigate_open.svg";
import expandIcon from "../../../assets/images/icons/plain/navigate_close.svg";
import addIcon from "../../../assets/images/icons/selected/add.svg";
import { AppState } from "../../../stores/app-mobx";
import { Constants } from "../../../globals/constants";
import TruncatedText from "../../../components/truncated-text/truncated-text";
import updatedIcon from "../../../assets/images/icons/selected/arrow_circle2.svg";
import { getLabel } from "../../../reflection/reflection";
import { UsageArea } from "../../../stores/area/area";

export default function AreaDataUsageProject({
                                                 project,
                                                 appStore
                                             }: { project: UsageProject, appStore: AppState }): JSX.Element {
    function expandOrCollapseCreationProjects() {
        setExpandedCreationProjects(!expandedCreationProjects);
    }

    const [expandedCreationProjects, setExpandedCreationProjects] = useState<boolean>(false);


    const areaRows: any[] = [];

    for (const a of project.areas) {
        areaRows.push(
            <TableRow key={a.id}>
                <TableCell>
                    <span onClick={() =>  {
                        appStore.setAreaId(a.project.categoryKey, a.projectId, a.id);
                        window.scrollTo({ top: 0, behavior: "instant" });
                    }}>
                        <SVG src={locateIcon} height="auto" width={20} title="Fokus"/>
                    </span>
                </TableCell>
                <TableCell textAlign="right">{a.id}</TableCell>
                <TableCell textAlign="right">{a.areaNEK2?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK3?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK4?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK5?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK6?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEKUnknown?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.eligibilityDisplayText}</TableCell>
                <TableCell textAlign="right">{a.effectiveAreaRounded.toLocaleString()}</TableCell>
            </TableRow>
        );
    }

    let creationProjects = null;

    if (expandedCreationProjects) {
        creationProjects = <Table basic="very" compact="very" size="small">
            <TableHeader>
                <TableRow>
                    <TableHeaderCell></TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "fullType")}</TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "municipalityName")}</TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "remarks")}</TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "status")}</TableHeaderCell>
                    <TableHeaderCell textAlign="center"><SVG src={updatedIcon} height="auto" width={20} title={getLabel(CreationProject.prototype, "updatedAt")}/></TableHeaderCell>
                    <TableHeaderCell></TableHeaderCell>
                </TableRow>
            </TableHeader>
            <TableBody>
                {project.compensations.map(c =>
                    <TableRow>
                        <TableCell verticalAlign="middle">
                            <div className="projectLinks">
                                <span
                                    onClick={() => {
                                        appStore.setProjectId(c.creationProject.categoryKey, c.creationProjectId, true);
                                        window.scrollTo({ top: 0, behavior: "instant" })
                                    }}>
                                    <SVG src={locateIcon} height="auto" width={20} title="Fokus"/>
                                </span>
                                <Link to={`kompensation/${c.id}/aendern`} preventScrollReset={true}>
                                    <SVG src={editIcon} height="auto" width={20} title="Bearbeiten"/>
                                </Link>
                                <Link to={`kompensation/${c.id}/loeschen`} preventScrollReset={true}>
                                    <SVG src={deleteIcon} height="auto" width={20} title="Löschen"/>
                                </Link>
                                <Link
                                    to={`/projekte/${Constants.projectCategoryCreation}/${c.creationProjectId}`}>{c.creationProject.name} ({c.creationProjectId})</Link>
                            </div>
                        </TableCell>
                        <TableCell>{c.creationProject.type}</TableCell>
                        <TableCell>{c.creationProject.municipalityName}</TableCell>
                        <TableCell><TruncatedText text={c.remarks}/></TableCell>
                        <TableCell>{c.creationProject.status}</TableCell>
                        <TableCell textAlign="center">{c.updatedAt}</TableCell>
                        <TableCell textAlign="right">{c.area.toLocaleString() ?? 0}</TableCell>
                    </TableRow>)}
                <TableRow>
                    <TableCell colSpan={7}>
                        <Link to={`kompensation/neu`} preventScrollReset={true}>
                            <SVG src={addIcon} height="auto" width={20} title="Kompensation hinzufügen"/>
                        </Link>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>;
    }

    return (
        <div className="areaDataUsageProject">
            <Grid columns={1}>
                <GridColumn>
                    <Table compact="very" basic="very" size="small" columns={10}>
                        <TableHeader>
                            <TableRow className="tableHeader">
                                <TableHeaderCell></TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "id")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK2")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK3")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK4")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK5")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK6")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEKUnknown")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "eligibilityDisplayText")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">TOTAL</TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {areaRows}
                            <TableRow className="italic">
                                <TableCell>TOTAL Beanspruchung</TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek2.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek3.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek4.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek5.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek6.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNekUnknown.toLocaleString()}</TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">{project.totalEffectiveAreaUsed.toLocaleString()}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <br/>
                    {project.compensations.length > 0 &&
                    <>
                        <Table className="tableWithNoBorder" basic="very" compact="very" size="small">
                            <TableBody>
                                <TableRow className="italic" onClick={() => expandOrCollapseCreationProjects()}>
                                    <TableCell>
                                        <span>TOTAL Kompensation </span>{expandedCreationProjects ?
                                        <SVG src={collapseIcon} height="auto" width={15} title="Zuklappen"/> :
                                        <SVG src={expandIcon} height="auto" width={15} title="Aufklappen"/>}
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>
                                    <TableCell textAlign="right">{project.totalAreaCompensated.toLocaleString()}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        {creationProjects}
                    </>
                    }
                    {project.compensations.length <= 0 &&
                    <Table className="tableWithNoBorder" basic="very" compact="very" size="small" columns={2}>
                        <TableBody>
                            <TableRow class="italic">
                                <TableCell>Keine Kompensation vorhanden</TableCell>
                                <TableCell textAlign="right">{project.totalAreaCompensated.toLocaleString()}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Link to={`kompensation/neu`} preventScrollReset={true}>
                                        <SVG src={addIcon} height="auto" width={20} title="Kompensation hinzufügen"/>
                                    </Link>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    }
                    <Divider/>
                    <Table className="tableWithNoBorder" compact="very" basic="very" size="small" columns={2}>
                        <TableBody>
                            <TableRow className="italic">
                                <TableCell>Gesamtbilanz</TableCell>
                                <TableCell textAlign="right">
                                    {project.totalAreaToCompensate > 0
                                        ? <span style={{ color: "red" }}>{(-project.totalAreaToCompensate).toLocaleString()}</span>
                                        : project.totalAreaToCompensate === 0
                                            ? project.totalAreaToCompensate.toLocaleString()
                                            : <span style={{ color: "green" }}>{(-project.totalAreaToCompensate).toLocaleString()}</span>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </GridColumn>
            </Grid>
        </div>
    );
}